(function() {
    angular.module("cstudioApp.services").factory('rivertownData', function($http, $q) {

        function getAllData(callback) {
            var defer = $q.defer();
            var promises = [];

            promises.push(getRivertownData());
            promises.push(getCinemaSouthData());
            promises.push(getNorthData());
            promises.push(getWoodlandData());
            promises.push(getCarouselData());
            promises.push(getPlazaData());
            promises.push(getMeridianData());
            promises.push(getLansingData());
            promises.push(getBentonHarborData());
            promises.push(getMtPleasantData());
            promises.push(getCrossroadsData());

            $q.all(promises)
                .then(function (response) {

                    var newArray = [];
                    //console.log(response);
                    _.each(response, function (r) {
                        newArray.push(_.get(r, 'data'));
                    });

                    //console.log(newArray);
                    //combine all cinema movie data
                    var merged = [].concat.apply([], newArray);

//                    console.log('merged',merged);

                    //combine all Sessions by FilmId
                    var combinedShowTimes = _(merged).flattenDeep().groupBy("FilmId").mapValues(function (x) { _.flatMapDeep(x, function (y) { return y.Sessions }) }).map(function (v, k) { ({ FilmId: Number(k), Sessions: v }) }).value();
                    //var movie1 = _.clone(combinedShowTimes[0], true);                    

                    //remap movies to have all showtimes
                    _.each(merged, function(movie) {
                        var combinedSessions = _.find(combinedShowTimes, { 'FilmId': movie.FilmId });
                        if (combinedSessions) {
                            movie.Sessions = combinedSessions.Sessions;
                        }
                    });

                    //remove duplicate movies
                    var unique = _.uniqBy(merged, 'FilmId');
                    //sort movies by name
                    var sorted = _.sortBy(unique, 'Title');

                    //Build out Session structure by Date
                    _.each(sorted, function(movie) {
                        movie.Sessions = _.groupBy(movie.Sessions, 'NewDate');
                        _.each(movie.Sessions, function(session, key) {
                            var combinedShowTimesV2 = _(session).flattenDeep().groupBy("NewDate").mapValues(function (x) { _.flatMapDeep(x, function (y) { return y.Times; }) }).map(function (v, k) { ({ NewDate: k, Times: v }) }).value();
                            movie.Sessions[key] =  _.groupBy(combinedShowTimesV2[0].Times, 'CinemaName');
                        });
                    });

                    //Build out Session structure by Cinema                    
                    _.each(sorted, function(movie) {        
                        _.forOwn(movie.Sessions, function(value, key) {                             
                            movie['Cinemas'] = movie['Cinemas'] || [];
                            _.forOwn(value, function(value2, key2) { 
                                movie.Cinemas[key2] = movie.Cinemas[key2] || [];
                                value2 = _.map(value2, function (v) {
                                    v.Day = key;
                                    var timestring = key + " " + v.StartTime;
                                    v['DateTime'] = moment(timestring, 'YYYY-MM-DD hh:mm A');
                                    //v['DateTime'] = moment(timestring).format();
                                    //v.DateTime = moment(timestring).format('YYYY-MM-DD hh:mm A')
                                    //console.log("DT", key + " " + v.StartTime);
                                    return v;
                                });
                                movie.Cinemas[key2]= _.union(movie.Cinemas[key2], value2);
                            });
                        });
                    });

                    //console.log('m', movie1);
                    //console.log('s', _.find(sorted, {'FilmId':movie1.FilmId})['Sessions']);
                    //console.log('c', _.find(sorted, {'FilmId':movie1.FilmId})['Cinemas']);

                    //console.log(sorted);
                    
                    window.AllMovieData = sorted;
                    console.log(sorted);
                    //sorted = _.get(sorted, '[0].data');

                    callback(sorted);
                    //only take first 20
                    //callback(sorted.slice(0,20));
                });
        }

        function getBentonHarborData() {
            var deferred = $q.defer();
            //console.log('getting benton harbor data');
            $http.get('https://moviecelebrationapi.peachdigital.com/movies/paginated/51/7815', { cache: true})
                .then(deferred.resolve);
            return deferred.promise;
        }

        function getCrossroadsData() {
            var deferred = $q.defer();
            //console.log('getting crossroads data');
            $http.get('https://moviecelebrationapi.peachdigital.com/movies/paginated/51/7816', { cache: true})
                .then(deferred.resolve);
            return deferred.promise;
        }

        function getNorthData() {
            var deferred = $q.defer();
            //console.log('getting north data');
            $http.get('https://moviecelebrationapi.peachdigital.com/movies/paginated/51/7817', { cache: true})
                .then(deferred.resolve);
            return deferred.promise;
        }

        function getCinemaSouthData() {
            var deferred = $q.defer();
            //console.log('getting south data');
            $http.get('https://moviecelebrationapi.peachdigital.com/movies/paginated/51/7818', { cache: true})
                .then(deferred.resolve);
            return deferred.promise;
        }

        function getLansingData() {
            var deferred = $q.defer();
            //console.log('getting lansing data');
            $http.get('https://moviecelebrationapi.peachdigital.com/movies/paginated/51/7819', { cache: true})
                .then(deferred.resolve);
            return deferred.promise;
        }

        function getMtPleasantData() {
            var deferred = $q.defer();
            //console.log('getting mt pleasant data');
            $http.get('https://moviecelebrationapi.peachdigital.com/movies/paginated/51/7820', { cache: true})
                .then(deferred.resolve);
            return deferred.promise;
        }

        function getRivertownData() {
            var deferred = $q.defer();
            //console.log('getting rivertown data');
            $http.get('https://moviecelebrationapi.peachdigital.com/movies/paginated/51/7821', { cache: true})
                .then(deferred.resolve);
            return deferred.promise;
        }

        function getWoodlandData() {
            var deferred = $q.defer();
            //console.log('getting woodland data');
            $http.get('https://moviecelebrationapi.peachdigital.com/movies/paginated/51/7822', { cache: true})
                .then(deferred.resolve);
            return deferred.promise;
        }

        function getCarouselData() {
            var deferred = $q.defer();
            //console.log('getting carousel data');
            $http.get('https://moviecelebrationapi.peachdigital.com/movies/paginated/51/7823', { cache: true})
                .then(deferred.resolve);
            return deferred.promise;
        }

        function getPlazaData() {
            var deferred = $q.defer();
            //console.log('getting plaza data');
            $http.get('https://moviecelebrationapi.peachdigital.com/movies/paginated/51/7824', { cache: true})
                .then(deferred.resolve);
            return deferred.promise;
        }

        function getMeridianData() {
            var deferred = $q.defer();
            //console.log('getting meridian data');
            $http.get('https://moviecelebrationapi.peachdigital.com/movies/paginated/51/7825', { cache: true})
                .then(deferred.resolve);
            return deferred.promise;
        }

        return {
            getAllData: getAllData
        };
    });
})();